<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="div-conteneur">
  <mat-tab-group (selectedTabChange)="onTabChange($event)" preserveContent>
    <!-- Recrutement tab -->
    <mat-tab label="RECRUTEMENT">
      <div class="row mt-4 mb-3">
        <div class="col flex-container end align-items-center">
          <div>
            <button mat-stroked-button class="bt-table-defaut mr-5" (click)="exporterEnMasseRecrutement()">
              <mat-icon>download</mat-icon>Exporter
            </button>
          </div>
          <div>
            <button mat-stroked-button class="bt-table-defaut mr-5" (click)="modifierEnMasseRecrutement()">
              <mat-icon>edit</mat-icon>Modifier en masse
            </button>
          </div>
          @if (isAdmin) {
            <div>
              <button mat-stroked-button class="bt-table-defaut mr-5" (click)="supprimerEnMasseRecrutement()">
                <mat-icon>delete</mat-icon> Supprimer en masse
              </button>
            </div>
          }
          <div>
            <button
              mat-stroked-button
              class="bt-table-defaut mr-5"
              (click)="togglePanelRecrutement()"
              [style]="panelOpenStateRecrutement ? 'border: 2px solid #405d9c;' : ''"
              >
              @if (!panelOpenStateRecrutement) {
                <mat-icon>filter_alt</mat-icon>
              }
              @if (
                !panelOpenStateRecrutement &&
                ((filterSubject | async)?.emetteur ||
                (filterSubject | async)?.dateCreationStart ||
                (filterSubject | async)?.dateCreationEnd ||
                (filterSubject | async)?.statut ||
                (filterSubject | async)?.direction ||
                (filterSubject | async)?.serviceFonctionnel ||
                (filterSubject | async)?.numeroPoste ||
                ((filterSubject | async)?.agentRenouveleId || (filterSubject | async)?.agentRenouvele) ||
                (filterSubject | async)?.typeRecrutement)
                ) {
                <mat-icon
                  class="icon-filtre-check"
                  >check_circle</mat-icon
                  >
                }

                @if (panelOpenStateRecrutement) {
                  <mat-icon>filter_alt</mat-icon>
                }
                @if (!panelOpenStateRecrutement) {
                  <span> {{ filtrer_libelle$ | async }}</span>
                }
                @if (panelOpenStateRecrutement) {
                  <span> Liste des filtres </span>
                }
                @if (!panelOpenStateRecrutement) {
                  <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                }
                @if (panelOpenStateRecrutement) {
                  <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                }
              </button>
            </div>
          </div>
        </div>
        <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRecrutement" style="width: 100%">
          <app-filter-controls
            (filterApplied)="onFilterApplied($event)"
            [showDirection]="true"
            [showService]="true"
            [showNumeroPoste]="true"
            [showDetenteurPoste]="true"
            [showTypeRecrutement]="true"
          ></app-filter-controls>
        </mat-expansion-panel>

        <app-data-table-optimized
          #dataTableRecrutement
          [displayedColumns]="recrutementDisplayedColumns"
          [getData]="getDemandesRecrutementData"
          [externalFilter$]="filterSubject"
          [cellStyleCss]="demandesCellStyleCss"
          [hasView]="true"
          [hasPagination]="true"
          [selectable]="true"
          [editable]="true"
          [deletable]="true"
          [downloadable]="true"
          [downloadablePJ]="true"
          [downloadablePJ_hidden]="false"
          (editItemEvent)="editDemande($event)"
          (deleteItemEvent)="deleteDemande($event)"
          (downloadItemEvent)="downloadDemande($event)"
          (downloadPJEvent)="downloadPJ($event)"
          (showDetail)="viewPdfDtails($event)"
          >
        </app-data-table-optimized>
      </mat-tab>

      <!-- Renouvellement tab -->
      <mat-tab label="RENOUVELLEMENT">
        <div class="row mt-4 mb-3">
          <div class="col flex-container end align-items-center">
            <div>
              <button mat-stroked-button class="bt-table-defaut mr-5" (click)="exporterEnMasseRenouvellement()">
                <mat-icon>download</mat-icon>Exporter
              </button>
            </div>
            <div>
              <button mat-stroked-button class="bt-table-defaut mr-5" (click)="modifierEnMasseRenouvellement()">
                <mat-icon>edit</mat-icon>Modifier en masse
              </button>
            </div>
            @if (isAdmin) {
              <div>
                <button mat-stroked-button class="bt-table-defaut mr-5" (click)="supprimerEnMasseRenouvellement()">
                  <mat-icon>delete</mat-icon> Supprimer en masse
                </button>
              </div>
            }
            <div>
              <button
                mat-stroked-button
                class="bt-table-defaut mr-5"
                (click)="togglePanelRenouvellement()"
                [style]="panelOpenStateRenouvellement ? 'border: 2px solid #405d9c;' : ''"
                >
                @if (!panelOpenStateRenouvellement) {
                  <mat-icon>filter_alt</mat-icon>
                }
                @if (
                  !panelOpenStateRenouvellement &&
                  ((filterSubject | async)?.emetteur ||
                  (filterSubject | async)?.dateCreationStart ||
                  (filterSubject | async)?.dateCreationEnd ||
                  (filterSubject | async)?.statut ||
                  (filterSubject | async)?.direction ||
                  (filterSubject | async)?.serviceFonctionnel ||
                  (filterSubject | async)?.numeroPoste ||
                  ((filterSubject | async)?.agentRenouveleId || (filterSubject | async)?.agentRenouvele) ||
                  (filterSubject | async)?.typeRenouvellement)
                  ) {
                  <mat-icon
                    class="icon-filtre-check"
                    >check_circle</mat-icon
                    >
                  }
                  @if (panelOpenStateRenouvellement) {
                    <mat-icon>filter_alt</mat-icon>
                  }
                  @if (panelOpenStateRenouvellement) {
                    <span> Liste des filtres </span>
                  }
                  @if (!panelOpenStateRenouvellement) {
                    <span> {{ filtrer_libelle$ | async }}</span>
                  }
                  @if (!panelOpenStateRenouvellement) {
                    <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                  }
                  @if (panelOpenStateRenouvellement) {
                    <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                  }
                </button>
              </div>
            </div>
          </div>
          <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateRenouvellement" style="width: 100%">
            <app-filter-controls
              (filterApplied)="onFilterApplied($event)"
              [showDirection]="true"
              [showService]="true"
              [showNumeroPoste]="true"
              [showAgentRenouvele]="true"
              [showTypeRenouvellement]="true"
              >
            </app-filter-controls>
          </mat-expansion-panel>
          <app-data-table-optimized
            #dataTableRenouvellement
            [displayedColumns]="demandesDisplayedColumns"
            [getData]="getDemandesRenouvellementData"
            [externalFilter$]="filterSubject"
            [cellStyleCss]="demandesCellStyleCss"
            [hasView]="true"
            [hasPagination]="true"
            [selectable]="true"
            [editable]="true"
            [deletable]="true"
            [downloadable]="true"
            [downloadablePJ]="true"
            [downloadablePJ_hidden]="false"
            (editItemEvent)="editDemande($event)"
            (deleteItemEvent)="deleteDemande($event)"
            (downloadItemEvent)="downloadDemande($event)"
            (downloadPJEvent)="downloadPJ($event)"
            (showDetail)="viewPdfDtails($event)"
            >
          </app-data-table-optimized>
        </mat-tab>

        <mat-tab label="VUE GLOBALE DEMANDES REFUSEES">
          <div class="d-flex align-items-center justify-content-between w-100">
            <mat-radio-group
              class="d-flex align-items-center"
              aria-label="Choisir une option"
              [(ngModel)]="isRecrutementActive"
              style="position: relative; gap: 10px"
              (change)="radioChange($event)"
              [ngModelOptions]="{ standalone: true }"
              >
              <mat-radio-button
                class="custom-radio-button"
                [value]="true"
                [ngClass]="{ active: isRecrutementActive }"
                [checked]="isRecrutementActive"
                >
                <span style="cursor: pointer">RECRUTEMENT</span>
              </mat-radio-button>
              <mat-radio-button class="custom-radio-button" [value]="false" [ngClass]="{ active: !isRecrutementActive }">
                <span style="cursor: pointer"> RENOUVELLEMENT </span>
              </mat-radio-button>
            </mat-radio-group>
            <button
              mat-stroked-button
              class="bt-table-defaut mr-5"
              (click)="togglePanelVueGlobale()"
              [style]="panelOpenStateVueGlobale ? 'border: 2px solid #405d9c;' : ''"
              >
              @if (!panelOpenStateVueGlobale) {
                <mat-icon>filter_alt</mat-icon>
              }
              @if (
                !panelOpenStateVueGlobale &&
                ((filterSubject | async)?.emetteur ||
                (filterSubject | async)?.dateCreationStart ||
                (filterSubject | async)?.dateCreationEnd ||
                (filterSubject | async)?.statut ||
                (filterSubject | async)?.direction ||
                (filterSubject | async)?.serviceFonctionnel ||
                (filterSubject | async)?.numeroPoste ||
                ((filterSubject | async)?.agentRenouveleId || (filterSubject | async)?.agentRenouvele) ||
                ((filterSubject | async)?.typeRecrutement && isRecrutementActive) ||
                ((filterSubject | async)?.typeRenouvellement && !isRecrutementActive))
                ) {
                <mat-icon
                  class="icon-filtre-check"
                  >check_circle</mat-icon
                  >
                }
                @if (panelOpenStateVueGlobale) {
                  <mat-icon>filter_alt</mat-icon>
                }
                @if (panelOpenStateVueGlobale) {
                  <span>Liste des filtres</span>
                }
                @if (!panelOpenStateVueGlobale) {
                  <span> {{ filtrer_libelle$ | async }}</span>
                }
                @if (!panelOpenStateVueGlobale) {
                  <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                }
                @if (panelOpenStateVueGlobale) {
                  <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                }
              </button>
            </div>
            <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenStateVueGlobale" style="width: 100%">
              <app-filter-controls
                (filterApplied)="onFilterApplied($event)"
                [showDirection]="true"
                [showService]="true"
                [showNumeroPoste]="true"
                [showDetenteurPoste]="isRecrutementActive"
                [showAgentRenouvele]="!isRecrutementActive"
                [showTypeRecrutement]="isRecrutementActive"
                [showTypeRenouvellement]="isRenouvellementActive$ | async"
                >
              </app-filter-controls>
            </mat-expansion-panel>

            <!-- LISTE RECRUTEMENT REFUSEES VUE GLOBALE -->
            @if (isRecrutementActive) {
              <div class="row mt-2 mb-3">
                <app-data-table-optimized
                  #dataTableRecrutementVueGlobale
                  [displayedColumns]="recrutementDisplayedColumns"
                  [getData]="getDemandesRecrutementRefusees"
                  [externalFilter$]="filterSubject"
                  [cellStyleCss]="demandesCellStyleCss"
                  [hasView]="true"
                  [hasPagination]="true"
                  [selectable]="false"
                  [editable]="false"
                  [deletable]="false"
                  [downloadable]="true"
                  [downloadablePJ]="false"
                  [downloadablePJ_hidden]="false"
                  (downloadItemEvent)="downloadDemande($event)"
                  (downloadPJEvent)="downloadPJ($event)"
                  (showDetail)="viewPdfDtails($event)"
                  >
                </app-data-table-optimized>
              </div>
            }
            <!-- LISTE RENOUVELLEMENT REFUSEES VUE GLOBALE -->

            @if (!isRecrutementActive) {
              <div class="row mt-2 mb-3">
                <app-data-table-optimized
                  #dataTableRenouvellementVueGlobale
                  [displayedColumns]="demandesDisplayedColumns"
                  [getData]="getDemandesRenouvellementRefusees"
                  [externalFilter$]="filterSubject"
                  [cellStyleCss]="demandesCellStyleCss"
                  [hasView]="true"
                  [hasPagination]="true"
                  [selectable]="false"
                  [editable]="false"
                  [deletable]="false"
                  [downloadable]="true"
                  [downloadablePJ]="false"
                  [downloadablePJ_hidden]="false"
                  (downloadItemEvent)="downloadDemande($event)"
                  (downloadPJEvent)="downloadPJ($event)"
                  (showDetail)="viewPdfDtails($event)"
                  >
                </app-data-table-optimized>
              </div>
            }
          </mat-tab>
        </mat-tab-group>
      </div>
